module.exports = __webpack_public_path__ + "beb1be99ed28367ab38fe9d15cab881f.MP3";